// extracted by mini-css-extract-plugin
module.exports = {"header":"LinkBlock_header__Znj0k","container":"LinkBlock_container__1UBLh","link":"LinkBlock_link__62NVE"};